import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../controller/c_auth";
import {useAppDispatch} from "../../app/hooks";
export default function AdminLogin() {
  const dispatch=useAppDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    remember: true,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [status, setStatus] = useState("idle"); // idle | loading | error
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((p) => ({
      ...p,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");

    const response = await loginUser({
      email: formData.email,
      password: formData.password,
    });
    

    if (response.state && response.state==='success') {
      setStatus("idle");
      dispatch({type:"auth/loginSuccess",payload:response.admin})
      localStorage.setItem("userToken",response.admin.token);
      navigate("/admin/dashboard", { replace: true });
      return;
    } else {
      setStatus("error");
      setErrorMsg(response.message || "Invalid email or password.");
      return;
    }
  };

  return (
    <div className="admin-auth-page">
      <div className="admin-auth-card">
        <div className="text-center mb-4">
          <div className="admin-auth-icon" aria-hidden="true">
            <i className="bi bi-shield-lock" />
          </div>
          <h1 className="h4 fw-bold mt-3 mb-1 text-white">Admin Login</h1>
          <p className="text-white-50 mb-0">
            Sign in to manage the AIWC Community.
          </p>
        </div>

        {status === "error" && (
          <div className="alert alert-danger py-2" role="alert">
            {errorMsg}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label text-white-50">Email</label>
            <div className="input-group">
              <span className="input-group-text bg-dark text-white-50 border-secondary">
                <i className="bi bi-envelope" />
              </span>
              <input
                type="email"
                name="email"
                className="form-control bg-dark text-light border-secondary"
                placeholder="admin@aiw.com"
                value={formData.email}
                onChange={handleChange}
                required
                autoComplete="email"
              />
            </div>
          </div>

          <div className="mb-2">
            <label className="form-label text-white-50">Password</label>
            <div className="input-group">
              <span className="input-group-text bg-dark text-white-50 border-secondary">
                <i className="bi bi-key" />
              </span>

              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control bg-dark text-light border-secondary"
                placeholder="••••••••"
                value={formData.password}
                onChange={handleChange}
                required
                autoComplete="current-password"
              />

              <button
                type="button"
                className="btn btn-outline-light border-secondary"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                title={showPassword ? "Hide password" : "Show password"}
              >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`} />
              </button>
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-between mt-3 mb-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="remember"
                name="remember"
                checked={formData.remember}
                onChange={handleChange}
              />
              <label className="form-check-label text-white-50" htmlFor="remember">
                Remember me
              </label>
            </div>

            <button type="button" className="btn btn-link text-info p-0">
              Forgot password?
            </button>
          </div>

          <div className="d-grid">
            <button
              type="submit"
              className="btn custom-btn-login btn-lg"
              disabled={status === "loading"}
            >
              {status === "loading" ? "Signing in..." : "Sign In"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
